import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { takeUntil } from 'rxjs';
import { FormControlService } from '../form-control.service';
import { ControlValueAccessorImpl } from '../ng-material-impl/control-value-accessor.impl';
import createControlValueAccessorProvider from '../utils/create-control-value-accessor-provider';
import { ChecklistFormControlService } from './checklist-form-control.service';

@Component({
  selector: 'ss-core-checklist-form-control',
  templateUrl: './checklist-form-control.component.html',
  styleUrls: ['./checklist-form-control.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'full-stretch flex-row flex--align-start'
  },
  providers: [
    FormControlService,
    ChecklistFormControlService,
    createControlValueAccessorProvider(ChecklistFormControlComponent)
  ]
})
export class ChecklistFormControlComponent extends ControlValueAccessorImpl<any[]> {

  @ViewChild(MatSelect)
  private _select: MatSelect

  readonly labelObs = this._formControlService.labelObs
  readonly allSelectedObs = this._checklistFormControlService.allSelectedObs;
  readonly showSelectAllObs = this._checklistFormControlService.showSelectAllObs;

  readonly listItemsSubject = this._checklistFormControlService.listItemsSubject
  @Input() get listItems() {
    return this.listItemsSubject.value
  }
  set listItems(value) {
    this.listItemsSubject.next(value)
  }

  readonly listItemsSelectedObs = this._checklistFormControlService.listItemsSelectedObs;
  readonly selectedItemsSubject = this._checklistFormControlService.selectedItemsSubject;
  readonly selectedValuesSubject = this._checklistFormControlService.selectedValuesSubject;
  readonly disabledSubject = this._checklistFormControlService.disabledSubject;
  readonly canUserDisableSubject = this._checklistFormControlService.canUserDisableSubject;
  readonly readOnlyObs = this._formControlService.readOnlyObs
  get selectedValues() {
    return this.selectedValuesSubject.value;
  }
  constructor(
    private readonly _checklistFormControlService: ChecklistFormControlService
  ) {
    super()


  }

  ngAfterViewInit() {

    this._select.valueChange.pipe(
      takeUntil(this._destroy)
    )
      .subscribe(value => {
        if (value === this.selectedValues) {
          return
        }
        this.selectedValuesSubject.next(value)
      })
  }

  selectAll() {
    this._checklistFormControlService.selectAll();
  }

  trackyByValue(idx: number, item: { value: any }) {
    return 'checklist-' + item.value
  }

  setChecked(value: any, checked: boolean) {
    this._checklistFormControlService.setChecked(value, checked);
  }
}
